export default {
  hero: {
    title: '리소스 센터',
    subtitle: '아시아태평양 기업 IT 서비스에 필요한 컴플라이언스 브리핑, 운영 가이드, 제공 템플릿, 정리된 이벤트 자료를 확인해 보세요.',
    imageAlt: '리소스 센터 배경 이미지',
    searchPlaceholder: '인사이트, 문서 또는 이벤트 검색...'
  },
  tabs: {
    all: '전체 자료',
    insights: '산업 인사이트',
    downloads: '다운로드',
    knowledge: '지식 베이스',
    events: '이벤트 및 소식'
  },
  insights: {
    title: '산업 인사이트',
    subtitle: '웹사이트, 고객 지원, CRM, 운영 팀을 위한 데이터 보호, 관리형 서비스 제공, 클라우드 복원력 관련 핵심 관찰을 정리했습니다.',
    viewAll: '모든 인사이트 보기',
    readMore: '더 읽기',
    items: [
      {
        id: 1,
        title: '2026 싱가포르 PDPA 핵심 포인트: 거버넌스, DPO 책임, ICT 통제',
        description: '공개 웹사이트, 고객 지원, 서드파티 처리 경계, 침해 대응 준비에 초점을 맞춘 PDPC 자료의 실무형 요약입니다.',
        image: '/images/resourceCenter/insight-report.jpg',
        badge: '컴플라이언스',
        badgeColor: 'bg-blue-600',
        date: '2026년 4월 10일',
        readTime: '8분 읽기',
        author: 'Mingyu Zhang',
        authorAvatar: '/images/resourceCenter/author-zhang.png'
      },
      {
        id: 2,
        title: '한국 PIPA 2026 실무 관찰: 국경 간 처리와 위탁 처리 관리',
        description: '웹사이트, 지원 채널, 지역 제공 모델을 운영하는 다국적 조직에서 자주 발생하는 PIPA 적용 이슈를 구조적으로 정리했습니다.',
        image: '/images/resourceCenter/insight-singapore-pdpa.jpg',
        badge: '정책',
        badgeColor: 'bg-green-600',
        date: '2026년 4월 9일',
        readTime: '7분 읽기',
        author: 'Meiling Lin',
        authorAvatar: '/images/resourceCenter/author-lin.png'
      },
      {
        id: 3,
        title: '클라우드 복원력 기준선: 다지역 복구와 서비스 복원 순서',
        description: '웹사이트, 고객 서비스 채널, 알림 흐름, CRM 플랫폼을 위한 복구 우선순위, 런북, 복원력 의사결정 가이드를 제공합니다.',
        image: '/images/resourceCenter/insight-korea-pipa.jpg',
        badge: '아키텍처',
        badgeColor: 'bg-red-600',
        date: '2026년 4월 12일',
        readTime: '9분 읽기',
        author: 'Minsu Kim',
        authorAvatar: '/images/resourceCenter/author-kim.png'
      }
    ]
  },
  downloads: {
    title: '다운로드',
    subtitle: '내부 검토, 고객 보고, 관리형 서비스 전환에 활용할 수 있는 상세 PDF 체크리스트와 템플릿을 다운로드하세요.',
    viewAll: '모든 자료 보기',
    action: '다운로드',
    items: [
      {
        id: 1,
        title: 'APAC 데이터 보호 준비도 체크리스트',
        description: '웹사이트, 지원 운영, CRM, 마케팅 자동화, 서드파티 SaaS 거버넌스를 위한 실무 체크리스트입니다.',
        badge: '체크리스트',
        badgeClass: 'text-blue-600 bg-blue-50',
        iconBg: 'bg-blue-100 text-blue-600',
        iconClass: 'fas fa-list-check text-blue-600',
        date: '2026년 4월 업데이트',
        fileInfo: 'PDF 체크리스트'
      },
      {
        id: 2,
        title: '다지역 재해 복구 런북 템플릿',
        description: '복구 우선순위, 커뮤니케이션, 승인 경로, 훈련 회고를 담은 즉시 활용 가능한 템플릿입니다.',
        badge: '템플릿',
        badgeClass: 'text-green-600 bg-green-50',
        iconBg: 'bg-green-100 text-green-600',
        iconClass: 'fas fa-file-lines text-green-600',
        date: '2026년 4월 업데이트',
        fileInfo: 'PDF 런북 템플릿'
      },
      {
        id: 3,
        title: '관리형 서비스 전환 및 오픈 체크리스트',
        description: '신규 프로젝트, 벤더 전환, 운영 인수, 오픈 전 검수에 사용할 수 있는 인수인계 체크리스트입니다.',
        badge: '전달',
        badgeClass: 'text-purple-600 bg-purple-50',
        iconBg: 'bg-purple-100 text-purple-600',
        iconClass: 'fas fa-clipboard-check text-purple-600',
        date: '2026년 4월 업데이트',
        fileInfo: 'PDF 전환 체크리스트'
      }
    ]
  },
  knowledge: {
    title: '지식 베이스',
    subtitle: '플랫폼 운영, 장애 분류, 보안 검토, 관리형 서비스 실행에 초점을 맞춘 짧고 실용적인 문서를 제공합니다.',
    viewAll: '모든 문서 보기',
    readDoc: '문서 읽기',
    categories: {
      all: '전체 카테고리',
      operation: '운영',
      troubleshooting: '트러블슈팅',
      compliance: '컴플라이언스',
      security: '보안'
    },
    hotTitle: '인기 기술 문서',
    hotSubtitle: '운영 환경, 복구, 감사 대응 중심으로 정리했습니다.',
    operationTitle: '운영',
    troubleshootingTitle: '트러블슈팅',
    hotDocuments: [
      {
        id: 1,
        title: 'Kubernetes Control Plane 및 etcd 백업/복구 런북',
        description: 'kubeadm 클러스터, etcd 스냅샷, 제어면 검증, 서비스 진입 확인을 중심으로 운영 팀을 위한 내용을 담고 있습니다.',
        category: '운영',
        categoryClass: 'bg-blue-50 text-blue-600',
        iconBg: 'bg-blue-100 text-blue-600',
        iconClass: 'fas fa-server text-blue-600',
        views: '1.9k 조회',
        date: '2026년 4월',
        comments: '18개 토론'
      },
      {
        id: 2,
        title: '분산 장애 분류 및 커뮤니케이션 매트릭스',
        description: '서비스 장애 중 기술 분류, 비즈니스 영향 판단, 외부 커뮤니케이션을 정렬하는 실무 방법입니다.',
        category: '트러블슈팅',
        categoryClass: 'bg-red-50 text-red-600',
        iconBg: 'bg-red-100 text-red-600',
        iconClass: 'fas fa-bug text-red-600',
        views: '1.6k 조회',
        date: '2026년 4월',
        comments: '12개 토론'
      },
      {
        id: 3,
        title: '관리형 서비스 보안 점검 체크리스트',
        description: '권한, 로그, 변경 관리, 제3자 접근을 빠르게 점검할 수 있는 요약형 검토 리스트입니다.',
        category: '컴플라이언스',
        categoryClass: 'bg-green-50 text-green-600',
        iconBg: 'bg-green-100 text-green-600',
        iconClass: 'fas fa-shield-alt text-green-600',
        views: '1.3k 조회',
        date: '2026년 4월',
        comments: '9개 토론'
      }
    ],
    operationTips: [
      '제어면 변경 전 백업, 인증서, 복구 의존 요소를 먼저 검증하세요',
      '배포, 롤백, 변경 기록을 동일한 당직 핸드북에 유지하세요',
      '데이터베이스, 객체 스토리지, 큐에 대해 각각 별도의 백업 및 검증 주기를 정의하세요',
      '로그 보존 정책은 장애 분석, 감사, 고객 보고를 모두 고려해야 합니다'
    ],
    troubleshootingTips: [
      '사고를 고객 접점, 제어면, 데이터면, 외부 의존성으로 나누어 파악하세요',
      '한 명의 사고 책임자, 한 명의 비즈니스 조정자, 한 가지 외부 업데이트 리듬을 정하세요',
      '시스템 복구뿐 아니라 DNS, 인증서, 알림, 티켓 시스템 복구도 훈련하세요',
      '모든 포스트모템에서 장애 요인, 수동 절차, 벤더 의존성을 기록하세요'
    ]
  },
  events: {
    title: '이벤트 및 소식',
    subtitle: '컴플라이언스, 플랫폼 운영, 서비스 복원력 관련 완료된 세션의 요약과 실무 인사이트를 정리했습니다.',
    viewAll: '모든 이벤트 보기',
    featured: {
      badge: '세션 회고',
      title: '2026 APAC 데이터 복원력 및 컴플라이언스 라운드테이블 회고',
      description: 'IT 리더, DPO, 플랫폼 팀이 공유한 논의 결과와 선택지, 후속 과제를 정리한 회고입니다.',
      date: '2026년 3월 12일',
      location: '싱가포르 / 온라인 하이브리드',
      audience: 'IT 리더, DPO, 플랫폼 팀',
      status: '종료됨',
      metaNote: '세션 노트와 관련 자료가 보관되어 있습니다',
      action: '회고 보기'
    },
    recentTitle: '최근 회고',
    recentSubtitle: '아래 항목은 모두 완료된 세션의 회고 노트와 아카이브 자료입니다.',
    recentItems: [
      {
        id: 1,
        day: '26',
        month: '3월',
        dateBg: 'bg-blue-100 text-blue-700',
        badge: '회고',
        badgeClass: 'bg-blue-50 text-blue-700',
        title: '싱가포르 PDPA 및 침해 통지 실무 회고',
        icon: 'far fa-clock',
        info: '온라인 세션 · 노트 게시',
        action: '회고 보기',
        linkClass: 'text-blue-600 hover:text-blue-700'
      },
      {
        id: 2,
        day: '05',
        month: '3월',
        dateBg: 'bg-green-100 text-green-700',
        badge: '워크숍 회고',
        badgeClass: 'bg-green-50 text-green-700',
        title: 'Kubernetes Control Plane 및 etcd 백업 훈련 회고',
        icon: 'fas fa-map-marker-alt',
        info: '상하이 · 실습 요약',
        action: '회고 보기',
        linkClass: 'text-green-600 hover:text-green-700'
      },
      {
        id: 3,
        day: '20',
        month: '2월',
        dateBg: 'bg-purple-100 text-purple-700',
        badge: '라운드테이블 회고',
        badgeClass: 'bg-purple-50 text-purple-700',
        title: '지역 DR 훈련 설계 라운드테이블 회고',
        icon: 'far fa-clock',
        info: '온라인 라운드테이블 · 요약 아카이브',
        action: '회고 보기',
        linkClass: 'text-purple-600 hover:text-purple-700'
      },
      {
        id: 4,
        day: '16',
        month: '1월',
        dateBg: 'bg-red-100 text-red-700',
        badge: '브리핑 회고',
        badgeClass: 'bg-red-50 text-red-700',
        title: '관리형 서비스 전환 및 SLA 커뮤니케이션 브리핑 회고',
        icon: 'fas fa-map-marker-alt',
        info: '온라인 브리핑 · 자료 보관',
        action: '회고 보기',
        linkClass: 'text-red-600 hover:text-red-700'
      }
    ]
  },
  contactCta: {
    badge: '문의하기',
    title: '실제 비즈니스 상황에 맞는 자료와 가이드가 필요하신가요?',
    subtitle: '웹사이트 구축, 지역 운영, 관리형 서비스, 재해 복구 훈련, 고객 지원 최적화를 준비 중이라면 바로 문의해 주세요. 상황에 맞는 자료, 우선순위, 지역 지원 방안을 함께 정리해 드립니다.',
    highlights: [
      '웹사이트 및 지원 상담',
      '지역 제공 및 운영 정렬',
      '문서 요청 및 솔루션 논의'
    ],
    note: '중국 본토, 싱가포르, 일본, 한국 및 기타 APAC 운영 시나리오 지원 가능.',
    action: '문의 페이지로 이동'
  }
}
